import { useTranslation } from 'react-i18next';

export const useAdminTr = (
  keyPrefix: 'common' | 'companies' | 'users' | 'createUserForm'
) => useTranslation('admin', { keyPrefix });
